export const featureDataBalconyRenewal = {
    mainTitle: 'Why Choose HRD for Balcony Renewals?',
    items: [
        {
            number: '01',
            heading: 'Expert Restoration Team – Specialized in balcony repairs, waterproofing, and coatings.'
        },
        {
            number: '02',
            heading: 'Minimal Disruption – Efficient project management to limit inconvenience for residents and businesses.'
        },
        {
            number: '03',
            heading: 'High-Quality Materials – Using durable, weatherproof, and slip-resistant finishes.'
        },
        {
            number: '04',
            heading: 'Safety & Compliance – Adhering to all building codes, WorkSafeBC, and industry safety regulations.'
        },
        {
            number: '05',
            heading: 'Long-Term Protection – Ensuring balconies remain safe, functional, and visually appealing for years to come.'
        }
    ],
    title: "Revitalize Your Balconies with HRD",
    subtitle:
        'From multi-unit residential buildings to high-rise commercial properties, our expert team ensures stronger, safer, and longer-lasting balconies.',
    ctaText:
        'CONTACT US TODAY TO DISCUSS HOW WE CAN PROTECT AND ENHANCE YOUR PROPERTY!',
    backgroundImage: '/assets/imgs/services/9BalconyRenewal/featuregridSection/fondo.png'
};
